import React, { Component, Suspense } from "react";
import { withRouter } from "react-router";
import Toolbar from "./Toolbar/Toolbar";
import { connect } from "react-redux";
import * as commonAction from "../../store/common/actions";
import BottomBar from "../Bars/BottomBar/BottomBar";
import Dialog from "../UI/Dialog/Dialog";
import Loading from "../UI/Loading/Loading";
import "./Layout.css";

const PreviewSlider = React.lazy(() =>
  import("../PreviewSlider/PreviewSlider")
);
const Register = React.lazy(() => import("../Register/Register"));

class Layout extends Component {
  constructor(props) {
    super(props);
    this.props.setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }
  state = {
    showSlider: false,
    images: [
      // {
      //   url: "/images/1.jpg",
      //   text: " تنوع بیش از  ۳۰۰۰ + کالای سوپرمارکتی در آنی هایپر",
      // },
      {
        url: "/images/2.jpg",
        text: " انواع میوه و صیفی جات تازه در آنی هایپر",
      },
      {
        url: "/images/3.jpg",
        text: " مجموعه ای از بهترین رستوران ها و فست فودهای شهر در آنی مارکت",
      },
      { url: "/images/4.jpg", text: "ارسال سریع و مطمعن با سفیران آنی مارکت" },
      {
        url: "/images/logo_dark.svg",
        text: "",
      },
    ],
  };
  componentDidMount() {
    window.addEventListener("scroll", this.scroll_listener);
    window.addEventListener("resize", this.resize_listener);

    if (!localStorage.last_update) {
      this.setState({
        showSlider:
          window.innerWidth <= 600 &&
          !this.props.is_auth &&
          !this.props.location.pathname.includes("checkout-done"),
      });
      localStorage.setItem("last_update", Date.now());
    }
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scroll_listener);
    window.removeEventListener("resize", this.resize_listener);
  }

  scroll_listener = (e) =>
    this.props.setScrollPosition(e.srcElement.body.scrollTop);
  resize_listener = (e) =>
    this.props.setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });

  render() {
    const store_id =
      this.props.route && this.props.route.params
        ? this.props.route.params.store_id
        : null;
    const checkoutUrl = "/checkout/:store_name/:store_id/";

    return (
      <React.Fragment>
        {!this.state.showSlider ? (
          <section className={"Layout"}>
            {this.props.route.path !== checkoutUrl ? (
              <Toolbar route={this.props.route} />
            ) : null}
            <main>{this.props.children}</main>
            {this.props.route.path !== checkoutUrl ? (
              <Dialog
                style={{ backgroundColor: "#000" }}
                direction="up"
                fullScreen={false}
                scroll="body"
                backgroundColor={"#000"}
                open={this.props.registerDialog}
                onClose={() => this.props.toggleRegisterDialog()}
              >
                <Suspense fallback={<Loading />}>
                  <Register />
                </Suspense>
              </Dialog>
            ) : null}
            {this.props.route.path !== checkoutUrl ? (
              <BottomBar
                store_id={store_id}
                store_name={
                  this.props.route.params
                    ? this.props.route.params.store_name
                    : null
                }
              />
            ) : null}
            <Dialog fullScreen={true} open={this.props.loading}>
              <Loading position="fixed" />
            </Dialog>
          </section>
        ) : (
          <Suspense fallback={<Loading />}>
            <PreviewSlider
              images={this.state.images}
              offShowSlider={() => {
                this.setState({ showSlider: false });
              }}
            />
          </Suspense>
        )}
      </React.Fragment>
    );
  }
}

const setStore = (dispatch) => {
  return {
    setScrollPosition: (res) => dispatch(commonAction.setScrollPosition(res)),
    setWindowSize: (res) => dispatch(commonAction.setWindowSize(res)),
    toggleRegisterDialog: (res) =>
      dispatch(commonAction.toggleRegisterDialog(res)),
  };
};

const getStore = (state) => {
  return {
    registerDialog: state.common.registerDialog,
    modalContent: state.common.modalContent,
    loading: state.common.loading,
    is_auth: state.auth.is_auth,
    size: state.common.size,
  };
};

export default connect(getStore, setStore)(withRouter(Layout));
